import type { RouteLocationNormalized } from 'vue-router'
import { AppLayoutsEnum, AppLayoutToFileMap } from '../../layouts/layouts.types'
import { useFeatureFlags } from '@/services/featureFlags'

export async function loadLayoutMiddleware(route: RouteLocationNormalized): Promise<void> {
  const { layout } = route.meta
  const { isEnabled } = useFeatureFlags()

  // Check if global redesign flag is enabled and if we are on the default layout (or catalog route)
  // If so, override layout to redesign
  const isCatalogEntry = route.name === 'catalog' && route.query.view !== 'menu'
  let normalizedLayoutName = isCatalogEntry
    ? AppLayoutsEnum.modern
    : layout || AppLayoutsEnum.default

  // Logic to switch layout based on flag
  // If the route expects 'default' layout, and global redesign is ON, switch to 'modern'
  if (
    normalizedLayoutName === AppLayoutsEnum.default &&
    isEnabled('ff_redesign_global')
  ) {
    normalizedLayoutName = AppLayoutsEnum.modern
  }

  const fileName = AppLayoutToFileMap[normalizedLayoutName]
  const fileNameWithoutExtension = fileName.split('.vue')[0]

  const component = await import(`../../layouts/${fileNameWithoutExtension}.vue`)
  route.meta.layoutComponent = component.default
}
